enum ActionTypes {
	push = 'Backlink.push',
	pop = 'Backlink.pop',
}

export default ActionTypes;
